module.exports = __webpack_public_path__ + "img/cars.dec14abd.png";